import { InfiniteScroll, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import BatteryCard from 'components/BatteryCard';
import Grid from 'components/Grid';
import SearchFilters from 'components/SearchFilters';
import GridText from 'components/text/GridText';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BatteriesGrid: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { LOADING, SEARCH_PLACEHOLDER } = useTranslation();

    const { batteries, endingMessage, fetchNext, hasNextPage, isLoading, onSearch } = useData();

    return (
        <VerticalContainer className={`${className} ${styles.batteriesGrid}`} testId={testId}>
            <SearchFilters
                className={styles.searchFilters}
                onSearch={onSearch}
                placeholder={SEARCH_PLACEHOLDER}
            />

            <InfiniteScroll
                endingMessage={
                    <Wrapper className={styles.wrapper}>
                        <GridText text={isLoading ? LOADING : endingMessage} />
                    </Wrapper>
                }
                loader={
                    <Wrapper className={styles.wrapper}>
                        <GridText text={LOADING} />
                    </Wrapper>
                }
                className={styles.infiniteScroll}
                fetchNextPage={fetchNext}
                hasNextPage={hasNextPage}>
                <Grid className={styles.grid}>
                    {batteries.map(battery => (
                        <BatteryCard
                            cyclesTotal={battery.cyclesTotal}
                            cyclesUsed={battery.cyclesUsed}
                            dronesUsedWith={battery.dronesUsedWith}
                            isSyncStale={battery.isSyncStale}
                            key={battery.id}
                            lastSynced={battery.lastSynced}
                            name={battery.name}
                        />
                    ))}
                </Grid>
            </InfiniteScroll>
        </VerticalContainer>
    );
};

export default BatteriesGrid;
